module.exports = __webpack_public_path__ + "img/house-window.22b03d64.svg";